import { tv, type VariantProps } from 'tailwind-variants'

/** Field geometry can be shared without opting into responsive typography. */
export const triggerGeometryVariants = tv({
  variants: {
    size: {
      sm: 'h-[31px] px-4',
      md: 'h-[45px] px-4',
      lg: 'h-[56px] px-4'
    }
  },
  defaultVariants: {
    size: 'md'
  }
})

/** Shared field geometry and responsive typography for Select and DatePicker. */
export const triggerSizeVariants = tv({
  extend: triggerGeometryVariants,
  variants: {
    size: {
      sm: 'text-caption-lg font-semibold leading-[1.5]',
      md: 'text-body-md font-semibold leading-[1.5]',
      lg: 'text-body-lg font-semibold leading-[1.5]'
    }
  }
})

export type TriggerSize = NonNullable<
  VariantProps<typeof triggerSizeVariants>['size']
>
